export default __webpack_public_path__ + "static/media/Copay Medizen.f2f5fe97.jpg";